module.exports = __webpack_public_path__ + "img/17.2bb2df39.png";